'use client';

import { ReactNode, useMemo } from 'react';

import { GeoContextState, GeoContextStateValue } from './context';

export type StaticGeoProviderProps = {
    children: ReactNode;
    id: string;
};

export function StaticGeoProvider({ children, id }: StaticGeoProviderProps) {
    const state = useMemo<GeoContextStateValue>(
        () => ({
            id,
        }),
        [id]
    );

    return (
        <GeoContextState.Provider value={state}>
            {children}
        </GeoContextState.Provider>
    );
}
